







































































import { Component, Vue } from "vue-property-decorator";
import Setting from "@/models/setting";
import FormValidations from "@/helpers/validations";
import SettingsAPI from "@/services/settings";
import { LayoutModule } from "@/store/layout";
import UtilsAPI from "@/services/utils";

@Component
export default class Settings extends Vue {
  model: Setting = new Setting();

  formValidations = new FormValidations();
  loading = false;

  created(): void {
    this.getSettings();
  }

  async getSettings(): Promise<void> {
    try {
      const r = await SettingsAPI.getSettings();
      this.model = r;
    } catch (e) {
      console.log(e);
    }
  }

  validate(): void {
    const validForm = (this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();
    validForm ? this.save() : null;
  }

  async generateApiKey(): Promise<void> {
    LayoutModule.setDialogTitle("settings.generate_api_key");
    LayoutModule.setDialogType("primary");
    LayoutModule.setDialogCallback(
      async (): Promise<null> => {
        try {
          const r = await UtilsAPI.generate_api_key();
          this.model.apiKey = r.apiKey;
        } catch (e) {
          console.log(e);
        }

        // LayoutModule.showLoader();
        // await AdUnitsAPI.delete(id);
        // await this.getRecords();
        // LayoutModule.hideLoader();
        return null;
      }
    );
    LayoutModule.showDialog();
  }

  async save(): Promise<void> {
    try {
      await SettingsAPI.updateSettings(this.model);

      LayoutModule.setAlerts({
        text: this.$t("settings.responses.success_update").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }
  }
}
